
/**
 * The type of (redux) action to add the donorbox url.
 *
 * {
 *     type: ADD_DONORBOX_URL,
 *     token: string
 * }.
 */
export const ADD_DONORBOX_URL = 'ADD_DONORBOX_URL';

/**
 * The type of (redux) action to receive the donorbox url.
 *
 * {
 *     type: RECEIVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const RECEIVE_DONORBOX_URL = 'RECEIVE_DONORBOX_URL';

/**
 * The type of (redux) action to remove the donorbox url.
 *
 * {
 *     type: REMOVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const REMOVE_DONORBOX_URL = 'REMOVE_DONORBOX_URL';

/**
 * The type of (redux) action to remove the donorbox url.
 *
 * {
 *     type: REMOVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const REMOVE_MOBILE_DONORBOX_URL = 'REMOVE_MOBILE_DONORBOX_URL';


